import { render, staticRenderFns } from "./draws.vue?vue&type=template&id=02ff6d72"
import script from "./draws.vue?vue&type=script&lang=js"
export * from "./draws.vue?vue&type=script&lang=js"
import style0 from "./draws.vue?vue&type=style&index=0&id=02ff6d72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports